import { dlDispatchAmplEvent } from './dl.dispatchAmplEvent';
document.body.addEventListener('click', (event) => {
    if (event.target === null || !(event.target instanceof Element))
        return;
    const dataValue = event.target.closest('[data-ampl-event]')?.getAttribute('data-ampl-event');
    if (dataValue === null || dataValue === undefined)
        return;
    try {
        const [type, context] = JSON.parse(dataValue);
        dlDispatchAmplEvent(type, context);
    }
    catch (e) { }
});
